import React from "react";

interface LoaderProps {
  show?: boolean;
  text?: string;
}

export const Loader = (props: LoaderProps) => {
  const { show, text = props.text || "Please wait..." } = props;

  // If show is explicitly passed and false, don't render
  if (show === false) return null;

  return (
    <div
      className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
      style={{ backgroundColor: "rgba(0, 0, 0, 0.5)", zIndex: 9999 }}
    >
      <div
        className="modal-dialog modal-dialog-centered"
        style={{ width: "450px", maxWidth: "90%" }}
      >
        <div className="modal-content bg-white rounded shadow-sm">
          <div className="modal-body d-flex flex-column align-items-center justify-content-center py-10">
            <div
              className="spinner-border text-primary mb-3"
              role="status"
              style={{
                width: "100px",
                height: "100px",
                borderWidth: "0.25em",
              }}
            >
              <span className="visually-hidden">Loading...</span>
            </div>
            <div className="fs-1 fw-bold text-dark mt-20">{text}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
